// decrypt.js or utils.js

export const decryptCode = async (base64Data, customKey) => {
    try {
      // Step 1: Convert customKey to SHA-256 hash (32-byte)
      const encoder = new TextEncoder();
      const keyData = encoder.encode(customKey);
      const hashBuffer = await crypto.subtle.digest('SHA-256', keyData);
      // Step 2: Convert base64 to ArrayBuffer
      const binaryData = atob(base64Data);
      const buffer = new Uint8Array([...binaryData].map(c => c.charCodeAt(0)));
      // Step 3: Extract IV and ciphertext
      const iv = buffer.slice(0, 16);
      const encryptedData = buffer.slice(16);
      // Step 4: Import key into WebCrypto
      const cryptoKey = await crypto.subtle.importKey(
        'raw',
        hashBuffer,
        { name: 'AES-CBC' },
        false,
        ['decrypt']
      );
      // Step 5: Decrypt
      const decryptedBuffer = await crypto.subtle.decrypt(
        { name: 'AES-CBC', iv },
        cryptoKey,
        encryptedData
      );
      const decoder = new TextDecoder();
      const dataDecrypt = decoder.decode(decryptedBuffer);
      return dataDecrypt;
    } catch (err) {
      console.error('Decryption failed:', err.message);
      return null;
    }
  };
  